import { type SQL, sql } from "drizzle-orm";

import { wsMembershipAvailability } from "@/db/schema";
import { offlineThreshold } from "@/utils";

const handsFreeUpdatedAt = wsMembershipAvailability.mostRecentHandsFreeStatusUpdatedAt;

/**
 * Matches `isWorkspaceMembershipOffline`: offline when there is no hands-free heartbeat or it is older than
 * `offlineThreshold` minutes (unreachable via HF).
 */
export function sqlMembershipIsOffline(thresholdMinutes: number = offlineThreshold): SQL {
  return sql`(
    ${handsFreeUpdatedAt} IS NULL
    OR FLOOR(ABS(EXTRACT(EPOCH FROM (NOW() - ${handsFreeUpdatedAt}))) / 60) >= ${thresholdMinutes}
  )`;
}

/** Inverse of `sqlMembershipIsOffline`: heartbeat exists and is within `offlineThreshold` minutes. */
export function sqlMembershipIsOnline(thresholdMinutes: number = offlineThreshold): SQL {
  return sql`(
    ${handsFreeUpdatedAt} IS NOT NULL
    AND FLOOR(ABS(EXTRACT(EPOCH FROM (NOW() - ${handsFreeUpdatedAt}))) / 60) < ${thresholdMinutes}
  )`;
}
